import { FC, Fragment } from 'react'
import { HeadingTag } from '@/common/pd-meta-components-types'
import SemanticText from '@/components/standard/semantic-text'

// 组件属性接口定义
export interface PdTextMatchSupProps {
  text: string // 输入文本
  supClassName?: string // sup标签的Tailwind类名
  className?: string // 组件容器的类名
  as?: HeadingTag | null // 可选语义标签；未配置时保持原 span
}

// 文本匹配上标组件实现
const PdTextMatchSup: FC<PdTextMatchSupProps> = ({ text, supClassName, className, as }) => {
  // 处理空字符串情况
  if (!text || text.trim() === '') {
    return null
  }

  // 正则表达式匹配 [1] 模式
  const regex = /\[(\d+)\]/g
  const matches = Array.from(text.matchAll(regex))

  // 如果没有匹配项，直接返回原文本
  if (matches.length === 0) {
    return (
      <SemanticText as={as} defaultTag="span" className={className}>
        {text}
      </SemanticText>
    )
  }

  // 构建 JSX 元素数组
  const elements: JSX.Element[] = []
  let lastIndex = 0

  matches.forEach((match, index) => {
    const [fullMatch, content] = match
    const matchIndex = match.index!

    // 添加匹配前的普通文本
    if (matchIndex > lastIndex) {
      const beforeText = text.slice(lastIndex, matchIndex)
      elements.push(
        <span key={`text-${index}`} className={className}>
          {beforeText}
        </span>
      )
    }

    // 添加 sup 标签包裹的匹配内容
    elements.push(
      <sup key={`sup-${index}`} className={supClassName}>
        [{content}]
      </sup>
    )

    lastIndex = matchIndex + fullMatch.length
  })

  // 添加最后剩余的文本
  if (lastIndex < text.length) {
    const remainingText = text.slice(lastIndex)
    elements.push(
      <span key="text-end" className={className}>
        {remainingText}
      </span>
    )
  }

  return (
    <SemanticText as={as} defaultTag="span">
      {elements.map((element, index) => (
        <Fragment key={`fragment-${index}`}>{element}</Fragment>
      ))}
    </SemanticText>
  )
}

export default PdTextMatchSup
